export default class InputGetComparativeData
{
  constructor(startTime, endTime, orderBy, orderByType) 
  {
    this.startTime = startTime;
    this.endTime = endTime;
    this.orderBy = orderBy;
    this.orderByType = orderByType;
  }    
}